const { v4: uuidv4 } = require('uuid');

export default [
  {
    key: uuidv4(),
    name: null,
    fields: [
      {
        name: 'sonum',
        label: '# Sales Order',
        type: 'number',
        validation: 'required',
        dense: true,
        outlined: true,
        hideDetails: true,
        readonly: true
      },
      {
        name: 'pin',
        label: 'PIN',
        type: 'number',
        validation: 'required|max:4',
        dense: true,
        outlined: true,
        hideDetails: true,
        autofocus: true
      }
    ]
  }
];
